import { render, staticRenderFns } from "./DetailsInformationRenewe.vue?vue&type=template&id=12fa9f9e&"
import script from "./DetailsInformationRenewe.vue?vue&type=script&lang=js&"
export * from "./DetailsInformationRenewe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports